import React from "react";
import { Card } from "./styles";

import FilesView from "../../views/Files/index.jsx";

export default function Files() {
  return (
    <div>
      <Card>
        <FilesView />
      </Card>
    </div>
  );
}
